export const STEP_MS = 1000 / 60;
export const MAX_CATCHUP_STEPS = 5;
const EPSILON_MS = 1e-9;
export class FixedTickAccumulator {
    accumulatorMs = 0;
    invalidated = false;
    advance(deltaMs, step) {
        if (this.invalidated)
            return { steps: 0, alpha: 0, invalidated: true };
        this.accumulatorMs += Math.max(0, deltaMs);
        let steps = 0;
        while (this.accumulatorMs + EPSILON_MS >= STEP_MS &&
            steps < MAX_CATCHUP_STEPS) {
            step();
            this.accumulatorMs -= STEP_MS;
            if (this.accumulatorMs < EPSILON_MS)
                this.accumulatorMs = 0;
            steps += 1;
        }
        if (this.accumulatorMs + EPSILON_MS >= STEP_MS)
            this.invalidated = true;
        return {
            steps,
            alpha: this.accumulatorMs / STEP_MS,
            invalidated: this.invalidated,
        };
    }
    reset() {
        this.accumulatorMs = 0;
        this.invalidated = false;
    }
}
